module.exports = __webpack_public_path__ + "img/home_logo-2.f6e03ca.png";